var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0.34375C5.11513 0.34375 0.34375 5.11685 0.34375 11C0.34375 16.8866 5.11513 21.6562 11 21.6562C16.8849 21.6562 21.6562 16.8866 21.6562 11C21.6562 5.11685 16.8849 0.34375 11 0.34375ZM11 19.5938C6.25058 19.5938 2.40625 15.751 2.40625 11C2.40625 6.25217 6.25075 2.40625 11 2.40625C15.7477 2.40625 19.5938 6.25071 19.5938 11C19.5938 15.7493 15.751 19.5938 11 19.5938ZM12.8047 15.125C12.8047 16.1201 11.9951 16.9297 11 16.9297C10.0049 16.9297 9.19531 16.1201 9.19531 15.125C9.19531 14.1299 10.0049 13.3203 11 13.3203C11.9951 13.3203 12.8047 14.1299 12.8047 15.125ZM9.30832 6.04136L9.60051 11.8851C9.61421 12.1596 9.84075 12.375 10.1155 12.375H11.8845C12.1593 12.375 12.3858 12.1596 12.3995 11.8851L12.6917 6.04136C12.7064 5.74686 12.4716 5.5 12.1767 5.5H9.8233C9.52841 5.5 9.29358 5.74686 9.30832 6.04136Z",
    fill: "#FCA905"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.5b395173.svg";
export { ForwardRef as ReactComponent };